const canvasNodeName = 'CANVAS';

/* istanbul ignore next */
export const isCanvasElement = (target: EventTarget | null) =>
  target && (target as Element)?.nodeName === canvasNodeName;
